/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { getPageName } from 'services/utility'
import './index.scss'

const FooterItem = ({ subSection: { header, subSections } }) => {
  const [listOpen, setListOpen] = useState(false)
  const toggleList = () => {
    setListOpen(!listOpen)
  }

  return (
    <React.Fragment>
      <span
        className={listOpen ? 'footer-minus-icon' : 'footer-plus-icon'}
        onClick={() => toggleList()}
        onKeyPress={() => toggleList()}
        role="presentation"
      >
        {listOpen ? '-' : '+'}
      </span>
      <h3 className="global-footer__heading">{header}</h3>
      <ul className={`global-footer__list-wrapper ${listOpen ? 'open' : ''}`}>
        {subSections.map(({
            link: {
              clickThrough: { value },
              uid,
              title,
            },
          }) => {
            const content = value && value.replace(/cmpid-pagename/gi, getPageName())
            return (
              <li className="global-footer__list" key={uid}>
                <a className="global-footer__link" href={content}>
                  {title}
                </a>
              </li>
            )
          })}
      </ul>
    </React.Fragment>
  )
}

export default FooterItem



// WEBPACK FOOTER //
// ./components/cms/components/footer-global/footer-item.js